<div class="flex flex-col container justify-center content-center items-center w-[30rem]">
  <div class="m-3">
    <div class="card-icon-external-layer">
      <div class="card-icon-middle-layer">
        <div class="card-icon-inner-layer">
          <img class="absolute" src="./assets/icons/hexagonal-warning-sign.svg" alt="Warning Sign"/>
        </div>
      </div>
    </div>
  </div>
  <div class="font-bold text-lg text-center p-1">
    {{'cancel_prompt.title'|transloco}}
  </div>
  <div class="p-3 text-center text-justify">
    {{'cancel_prompt.description'|transloco}}
  </div>
  <button class="w-[18rem] m-1" edType="primary" edSize="large" (click)="onStayOnPageClick()" ed-button>{{'cancel_prompt.stay'|transloco}}</button>
  <button id="leave-page-btn" class="w-[18rem] m-1" edType="secondary" edSize="large" (click)="onLeavePageClick()" ed-button>{{'cancel_prompt.leave'|transloco}}</button>
</div>